import React, { useEffect, useState } from "react";
import ImageUpload from "../../components/DocUpload";
import SingleDropdown from "../../components/SingleDropdown";
import { AiFillPlusCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import "./Documents.css";
import axios from "axios";
import SmallLoader from "../../components/SmallLoader.js";
import { useNavigate } from "react-router-dom";
import constant from "../../constant/constant.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logout } from "../../store/authSlice.js";
import Popup from "../../components/Popup/Popup";
import { RiHonorOfKingsFill } from "react-icons/ri";

const Document = () => {
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const maxmedicalcertificate = 4;

  const [autoLoader, setAutoLoader] = useState(false);
  const [dataStatus, setDataStatus] = useState(false);
  const [adharextraDesing, setAdharextraDesing] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [initialAddressProofOptions, setInitialAddressProofOptions] = useState(
    []
  );
  const [certificateOptions, setCertificateOptions] = useState([]);
  const [complsoury, setComplsoury] = useState({});
  const [courseListed, setCourseListed] = useState([]);
  const [licenseOptions, setLicenseOptions] = useState([]);
  const [idProofTypeOptions, setIdProofTypeOptions] = useState([]);
  const [errorMsg, setErrorMsg] = useState({});
  const [isStatusChage, setIsStatusChange] = useState(false);
  const [comments, setComments] = useState("");
  const [admin, setAdmin] = useState(0);
  const [statusObj, setStatusObj] = useState({ type: "", clickType: "" });
  const [holdStatusVal, setHoldStatusVal] = useState({
    type: "",
    col: "",
    val: "",
  });
  const [warning, setWarning] = useState("");
  const excludeKeys = new Set([
    "status",
    "medical_cert_status",
    "doc_verify_status",
    "comment",
    "adhardocstatus",
    "addressproof_status",
    "certificate_status",
    "license_status",
    "id_proof_status"
  ]);

  const [documentsData, setDocumentsData] = useState({});
  const [selectedCertificates, setSelectedCertificates] = useState([]);
  const [selectedAddressProofs, setSelectedAddressProofs] = useState([]);
  const [selectedLicenseTypes, setSelectedLicenseTypes] = useState([]);
  const [selectedIdProofTypes, setSelectedIdProofTypes] = useState([]);

  // add section design code //
  const handleAddAddressProof = () => {
    //console.log("selectedAddressProofs",selectedAddressProofs,initialAddressProofOptions);
    if (selectedAddressProofs.length >= initialAddressProofOptions.length)
      return;
    setDocumentsData((prevState) => ({
      ...prevState,
      addressProofs: [
        ...prevState.addressProofs,
        {
          id: Date.now() + "_new",
          addProofType: {},
          addProofId: "",
          image: "",
          addressproof_status: 0,
          status: "1",
        },
      ],
    }));
  };

  const handleAddCertificate = () => {
    if (selectedCertificates.length >= certificateOptions.length) return;

    setDocumentsData((prevState) => ({
      ...prevState,
      certificates: [
        ...prevState.certificates,
        {
          id: Date.now() + "_new",
          certificateType: {},
          schoolName: "",
          c_place: "",
          c_passingYear: "",
          marksObtained: "",
          percentage: "",
          certificateNumber: "",
          courseName: "",
          image: "",
          certificate_status: 0,
          status: "1",
        },
      ],
    }));
  };

  const addLicense = () => {
    if (selectedLicenseTypes.length >= licenseOptions.length) return;
    setDocumentsData((prevState) => ({
      ...prevState,
      license: [
        ...prevState.license,
        {
          id: Date.now() + "_new",
          licenseType: {},
          instituteName: "",
          l_place: "",
          l_passingYear: "",
          licenseNumber: "",
          image: "",
          license_status: 0,
          status: "1",
        },
      ],
    }));
  };

  const addNewMedicalCertificate = () => {
    setDocumentsData((prevState) => ({
      ...prevState,
      medicalCertificates: [
        ...prevState.medicalCertificates,
        {
          id: Date.now() + "_new",
          image: "",
          medical_cert_status: 0,
          status: "1",
        },
      ],
    }));
  };
  //end//

  // handle delete section code //

  const handleDeleteAddressProof = (index, id) => {
    const updatedDocumentsData = {
      ...documentsData,
      addressProofs: documentsData.addressProofs.map((proof, i) =>
        i === index ? { ...proof, status: "0" } : proof
      ),
    };

    // Update the state with the new documentsData
    setDocumentsData(updatedDocumentsData);

    const lastOption =
      updatedDocumentsData.addressProofs[index].addProofType?.value;
    if (lastOption) {
      setSelectedAddressProofs((prevSelected) =>
        prevSelected.filter((item) => item !== lastOption)
      );
    }
    //deleteRecordDocument(id);
  };

  const handleDeleteCertificate = (index, id) => {
    const updatedCertificates = documentsData.certificates.map((cert, i) =>
      i === index ? { ...cert, status: "0" } : cert
    );
    setDocumentsData({ ...documentsData, certificates: updatedCertificates });

    const lastOption = documentsData.certificates[index].certificateType?.value;
    if (lastOption) {
      setSelectedCertificates((prevSelected) =>
        prevSelected.filter((item) => item !== lastOption)
      );
    }
    //deleteRecordDocument(id);
  };

  const removeLicense = (index, id) => {
    const updatedLicenses = documentsData.license.map((cert, i) =>
      i === index ? { ...cert, status: "0" } : cert
    );
    setDocumentsData({ ...documentsData, license: updatedLicenses });

    const lastOption = documentsData.license[index].licenseType?.value;
    if (lastOption) {
      setSelectedLicenseTypes((prevSelected) =>
        prevSelected.filter((item) => item !== lastOption)
      );
    }
    //deleteRecordDocument(id);
  };
  const deleteMedicalCertificate = (index, id) => {
    const updatedMedicalCertificate = documentsData.medicalCertificates.map(
      (cert, i) => (i === index ? { ...cert, status: "0" } : cert)
    );
    setDocumentsData({
      ...documentsData,
      medicalCertificates: updatedMedicalCertificate,
    });
    //deleteRecordDocument(id);
  };
  const deleteGraduationCertificate = (index, id) => {
    const updatedGraduationCertificates = documentsData.GraduationCertificates.map(
      (cert, i) => (i === index ? { ...cert, status: "0" } : cert)
    );
    setDocumentsData({
      ...documentsData,
      GraduationCertificates: updatedGraduationCertificates,
    });
    //deleteRecordDocument(id);
  };
  const deleteResume = (index, id) => {
    const updatedResume = documentsData.resume.map(
      (cert, i) => (i === index ? { ...cert, status: "0" } : cert)
    );
    setDocumentsData({
      ...documentsData,
      resume: updatedResume,
    });
    //deleteRecordDocument(id);
  };
  const deleteCOCInstructorCourse = (index, id) => {
    const updateCocInstructorCourse = documentsData.cocInstructorCourse.map(
      (cert, i) => (i === index ? { ...cert, status: "0" } : cert)
    );
    setDocumentsData({
      ...documentsData,
      cocInstructorCourse: updateCocInstructorCourse,
    });
    //deleteRecordDocument(id);
  };
  const deleteProofInstructorRating = (index, id) => {
    const updateProofInstructorRating = documentsData.proofInstructorRating.map(
      (cert, i) => (i === index ? { ...cert, status: "0" } : cert)
    );
    setDocumentsData({
      ...documentsData,
      proofInstructorRating: updateProofInstructorRating,
    });
    //deleteRecordDocument(id);
  };

  //

  const deleteIdProof = (index, id) => {
    const updatedMedicalCertificate = documentsData.id_proof.map(
      (cert, i) => (i === index ? { ...cert, status: "0" } : cert)
    );
    setDocumentsData({
      ...documentsData,
      id_proof: updatedMedicalCertificate,
    });
    //deleteRecordDocument(id);
  };
  
  //end 

  // handle dropdown change//
  const handleCertificateChange = (index, e) => {
    const { id, value } = e.target;
    // const updatedCertificates = documentsData.certificates.map((cert, i) =>
    //   i === index ? { ...cert, [id]: value } : cert
    // );
    //setDocumentsData({ ...documentsData, certificates: updatedCertificates });
    const updatedCertificates = [...documentsData.certificates];
    updatedCertificates[index][id] = value;
    setDocumentsData((prevState) => ({
      ...prevState,
      certificates: updatedCertificates,
    }));

    if (value.value !== "diploma" && value.value !== "degree") {
      setSelectedCertificates((prevSelected) => [...prevSelected, value.value]);
    }
    if (id === "certificateType") {
      handleOnChangeUpdate(
        value.value,
        "doc_type",
        value.value,
        updatedCertificates[index].id
      );
    }
  };

  const handleDropdownChangeLicense = (option, index) => {
    const updatedLicenses = [...documentsData.license];
    updatedLicenses[index].licenseType = option;

    setDocumentsData((prevState) => ({
      ...prevState,
      license: updatedLicenses,
    }));

    //setSelectedLicenseTypes((prevSelected) => [...prevSelected, option.value]);
    handleOnChangeUpdate(
      option.value,
      "doc_type",
      option.value,
      updatedLicenses[index].id
    );
  };

  const handleDropdownChangeAddress = (option, index) => {
    const updatedProofs = [...documentsData.addressProofs];
    updatedProofs[index].addProofType = option;
    setDocumentsData((prevState) => ({
      ...prevState,
      addressProofs: updatedProofs,
    }));
    setSelectedAddressProofs((prevSelected) => [...prevSelected, option.value]);
    handleOnChangeUpdate(
      option.value,
      "doc_type",
      option.value,
      updatedProofs[index].id
    );
  };

  const handleDropdownChangeIdProof = (option, index) => {
    const updatedIdProofs = [...documentsData.id_proof];
    updatedIdProofs[index].id_proof_type = option;

    setDocumentsData((prevState) => ({
      ...prevState,
      id_proof: updatedIdProofs,
    }));
    handleOnChangeUpdate(
      option.value,
      "doc_type",
      option.value,
      updatedIdProofs[index].id
    );
  };
  //end //

  //image upload code desing//
  const handleAadharImageUpload = (imageFile, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, "adhar", dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        aadharImage: imageUrl,
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        aadharImage: "",
      }));
    }
  };

  const handleAddressProofImageUpload = (index, imageFile, doc_type, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, doc_type, dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        addressProofs: prevState.addressProofs.map((proof, i) =>
          i === index ? { ...proof, image: imageUrl } : proof
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        addressProofs: prevState.addressProofs.map((proof, i) =>
          i === index ? { ...proof, image: "" } : proof
        ),
      }));
    }
  };
  const handleCertificateImageUpload = (index, imageFile, doc_type, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, doc_type, dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        certificates: prevState.certificates.map((cert, i) =>
          i === index ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        certificates: prevState.certificates.map((cert, i) =>
          i === index ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };
  const handleMedicalCertificateImageUpload = (id, imageFile, index, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, "medical", dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        medicalCertificates: prevState.medicalCertificates.map((cert) =>
          cert.id === id ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        medicalCertificates: prevState.medicalCertificates.map((cert) =>
          cert.id === id ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };

  const handleGraduationCertificatesImageUpload = (id, imageFile, index, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, "graduation", dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        graduationCertificates: prevState.graduationCertificates.map((cert) =>
          cert.id === id ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        graduationCertificates: prevState.graduationCertificates.map((cert) =>
          cert.id === id ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };

  const handleResumeImageUpload = (id, imageFile, index, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, "resume", dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        resume: prevState.resume.map((cert) =>
          cert.id === id ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        resume: prevState.resume.map((cert) =>
          cert.id === id ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };

  const handleCocInstructorCourseImageUpload = (id, imageFile, index, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, "coc_instructor", dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        cocInstructorCourse: prevState.cocInstructorCourse.map((cert) =>
          cert.id === id ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        cocInstructorCourse: prevState.cocInstructorCourse.map((cert) =>
          cert.id === id ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };

  const handleProofInstructorRatingImageUpload = (id, imageFile, index, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, "instructor_rating", dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        proofInstructorRating: prevState.proofInstructorRating.map((cert) =>
          cert.id === id ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        proofInstructorRating: prevState.proofInstructorRating.map((cert) =>
          cert.id === id ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };

  //

  const handleIdProofImageUpload = (id, imageFile, doc_type, dbid) => {
    if (imageFile) {
      uploadImageOnChangeUpdate(imageFile, doc_type, dbid);
      const imageUrl = URL.createObjectURL(imageFile);
      setDocumentsData((prevState) => ({
        ...prevState,
        id_proof: prevState.id_proof.map((cert) =>
          cert.id === id ? { ...cert, image: imageUrl } : cert
        ),
      }));
    } else {
      setDocumentsData((prevState) => ({
        ...prevState,
        id_proof: prevState.id_proof.map((cert) =>
          cert.id === id ? { ...cert, image: "" } : cert
        ),
      }));
    }
  };

  //end //

  //get avaialbe option //

  const getAvailableAddressProofOptions = () => {
    return initialAddressProofOptions.filter(
      (option) => !selectedAddressProofs.includes(option.value)
    );
  };

  const getAvailableCertificateOptions = () => {
    return certificateOptions.filter(
      (option) => !selectedCertificates.includes(option.value)
    );
  };

  const getAvailableLicenseOptions = () => {
    return licenseOptions.filter(
      (option) => !selectedLicenseTypes.includes(option.value)
    );
  };

  // const getAvailableIdProofOptions = () => {
  //   return idProofTypeOptions.filter(
  //     (option) => !selectedIdProofTypes.includes(option.value)
  //   );
  // };

  const getAvailableIdProofOptions = () => {
    return idProofTypeOptions.filter((option) => {
      const optionValue = option.value.replace("idproof_", "");
      return !selectedAddressProofs.includes(optionValue);
    });
  };

  //end//

  const handleChange = (index, field, value) => {
    const updatedAdhar = [...documentsData.adhar];
    updatedAdhar[index][field] = value;
    setDocumentsData((prevState) => ({
      ...prevState,
      adhar: updatedAdhar,
    }));
  };
  const handleLicenseChange = (index, field, value) => {
    const updatedLicenses = [...documentsData.license];
    updatedLicenses[index][field] = value;
    setDocumentsData((prevState) => ({
      ...prevState,
      license: updatedLicenses,
    }));
  };
  const handleIdProofNumberChange = (index, field, value) => {
    const updatedLicenses = [...documentsData.id_proof];
    updatedLicenses[index][field] = value;
    setDocumentsData((prevState) => ({
      ...prevState,
      id_proof: updatedLicenses,
    }));
  };

  const getRealTimeCount = (type) => {
    if (type == "addressproof") {
      return documentsData.addressProofs.filter(
        (addressProof) => addressProof.status === "1"
      ).length;
    } else if (type == "certificate") {
      return documentsData.certificates.filter(
        (certificates) => certificates.status === "1"
      ).length;
    } else if (type == "license") {
      return documentsData.license.filter(
        (certificates) => certificates.status === "1"
      ).length;
    } else if (type == "medical") {
      return documentsData.medicalCertificates.filter(
        (certificates) =>
          certificates.medical_cert_status !== "1" &&
          certificates.status === "1"
      ).length;
    } else if (type == "id_proof") {
      return documentsData.id_proof.filter(
        (certificates) =>
          certificates.id_proof_status !== "1" &&
          certificates.status === "1"
      ).length;
    } else if (type == "graduation") {
      return documentsData.graduationCertificates.filter(
        (certificates) =>
          certificates.graduation_cert_status !== "1" &&
          certificates.status === "1"
      ).length;
    } else if (type == "resume") {
      return documentsData.resume.filter(
        (certificates) =>
          certificates.resume_status !== "1" &&
          certificates.status === "1"
      ).length;
    } else if (type == "cocInstructorCourse") {
      return documentsData.cocInstructorCourse.filter(
        (certificates) =>
          certificates.coc_instructor_course_status !== "1" &&
          certificates.status === "1"
      ).length;
    } else if (type == "proofInstructorRating") {
      return documentsData.proofInstructorRating.filter(
        (certificates) =>
          certificates.proof_instructor_rating_status !== "1" &&
          certificates.status === "1"
      ).length;
    }
  };

  const validatedata = (doc_type, col, value, key) => {
    let newError = {};
    let return_st = true;
    const currentYear = new Date().getFullYear();
    newError = { ...errorMsg };
    if (doc_type === "adhar" && col === "doc_information") {
      const isValid = /^\d{12}$/.test(value);
      if (!isValid) {
        newError[key] = "Aadhar Number must be exactly 12 digits long.";
        return_st = false;
      } else {
        newError[key] = "";
      }
    } else if (doc_type === "passport" && col === "doc_information") {
      if (value.trim() === "") {
        newError.passport = "Passport can't empty";
        return_st = false;
      } else {
        newError.passport = "";
      }
    } else if (doc_type === "voter_id" && col === "doc_information") {
      if (value.trim() === "") {
        newError.voter_id = "Voter id can't empty";
        return_st = false;
      } else {
        newError.voter_id = "";
      }
    } else if (doc_type === "ration_card" && col === "doc_information") {
      if (value.trim() === "") {
        newError.ration_card = "Ration card can't empty";
        return_st = false;
      } else {
        newError.ration_card = "";
      }
    } else if (doc_type === "driving_licence" && col === "doc_information") {
      if (value.trim() === "") {
        newError.driving_licence = "Driving licence can't empty";
        return_st = false;
      } else {
        newError.driving_licence = "";
      }
    } else if (
      (doc_type === "10th" ||
        doc_type === "12th" ||
        doc_type === "diploma" ||
        doc_type === "degree") &&
      col === "other_json_data"
    ) {
      // Validate empty field
      if (
        value.trim() === "" &&
        !key.includes("certificateNumber") &&
        !key.includes("marksObtained") &&
        !key.includes("percentage") &&
        !key.includes("c_place")
      ) {
        newError[key] = "Field can't be empty";
        return_st = false;
      } else if (value.trim().length > 50) {
        newError[key] = "Maximum 50 character";
        return_st = false;
      }
      // Validate certificate number for '10th' and '12th'
      else if (
        (doc_type === "10th" || doc_type === "12th") &&
        key.includes("certificateNumber") &&
        !/^[A-Z0-9]+$/.test(value)
      ) {
        newError[key] = "Enter a valid role number";
        return_st = false;
      }
      // Validate certificate number for 'diploma' and 'degree'
      else if (
        (doc_type === "diploma" || doc_type === "degree") &&
        key.includes("certificateNumber") &&
        !/^[A-Z0-9]+$/.test(value)
      ) {
        newError[key] = "Enter a valid certificate number";
        return_st = false;
      } else if (key.includes("c_passingYear")) {
        if (!/^\d{4}$/.test(value) || value < 1900 || value > currentYear) {
          newError[key] = "Enter a valid passing year.";
          return_st = false;
        } else {
          newError[key] = "";
        }
      }
      // Validate marks obtained
      else if (
        key.includes("marksObtained") &&
        !/^\d{1,4}$/.test(value) &&
        value !== ""
      ) {
        newError[key] = "Enter a valid mark";
        return_st = false;
      }
      // Validate percentage
      else if (
        key.includes("percentage") &&
        !/^\d+(\.\d+)?$/.test(value) &&
        value !== ""
      ) {
        newError[key] = "Enter a valid percentage";
        return_st = false;
      } else if (key.includes("percentage") && parseInt(value) > 100) {
        newError[key] = "Max percentage value 100";
        return_st = false;
      }
      // Clear any previous error if validation is successful
      else {
        newError[key] = "";
      }
    } else if (
      (doc_type === "cpl_license" || doc_type === "rpc_license") &&
      col === "other_json_data"
    ) {
      // Validate empty field
      if (value.trim() === "") {
        newError[key] = "Field can't be empty";
        return_st = false;
      }
      // Validate license number for
      else if (key.includes("licenseNumber") && !/^[A-Z0-9]+$/.test(value)) {
        newError[key] = "Enter a valid license number";
        return_st = false;
      }
      // Validate passing year
      else if (key.includes("l_passingYear")) {
        if (!/^\d{4}$/.test(value) || value < 1900 || value > currentYear) {
          newError[key] = "Enter a valid passing year.";
          return_st = false;
        } else {
          newError[key] = "";
        }
      }
      // Clear any previous error if validation is successful
      else {
        newError[key] = "";
      }
    }

    newError = Object.fromEntries(
      Object.entries(newError).filter(([_, v]) => v !== "")
    );
    setErrorMsg(newError);
    return return_st; // Return true if no errors
  };

  const handleOnChangeUpdate = async (doc_type, col, val, dbid, key = "") => {
    console.log("key = ", key);
    let status = validatedata(doc_type, col, val, key);
    if (status && val !== "") {
      update_doc_data(doc_type, col, val, dbid, key);
    }
  };

  const getErrorMessage = (proofType, errorMsg) => {
    return proofType ? errorMsg[proofType] : null;
  };

  function uploadImageOnChangeUpdate(file, type, dbid) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    formData.append("dbid", dbid);
    axios
      .post(
        `${constant.base_url}/student/student_doc_billing.php?fun=upload_images`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Auth-Id": user.auth_id,
          },
        }
      )
      .then((response) => {
        let uploadedUrl = response.data.data.data.image.url;
        /*if(response.data.data.status===1 && String(dbid).includes("_new")){
        getDocument();
      }*/
        if (response.data.data.status === 1) {
          getDocument();
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        // Handle error
      });
  }
  function deleteRecordDocument(id) {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=deleterecord`,
      headers: { "Auth-Id": user.auth_id },
      data: { rec_id: id },
    })
      .then(function (response) {
        checkUserLogin(response);
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  }
  useEffect(() => {
    // let foundBlankField = false;
    // const newWarnings = [];
    // for (const category in documentsData) {
    //   documentsData[category].forEach(item => {
    //     Object.entries(item).forEach(([key, value]) => {
    //       if (!excludeKeys.has(key) && (value === null || (typeof value === 'string' && value.trim() === '')) ) {
    //         newWarnings.push(`Warning: '${key}' is blank in category '${category}' with ID '${item.id}'`);
    //       }
    //     });
    //   });
    // }
    // console.log("newWarnings",newWarnings);
    // if (foundBlankField) {
    //   setWarning('Warning: Some fields are missing or blank.');
    // } else {
    //   setWarning('');
    // }
  }, [documentsData]);
  useEffect(() => {
    getDocument();
  }, []);

  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };

  const closePopup = () => {
    setIsStatusChange(false);
    setComments("");
  };
  const onSubmitPop = () => {
    if (statusObj.clickType === "1" && comments == "") {
      toast.warn("Please enter reason");
      return false;
    }
    const docobj = holdStatusVal.type;
    const col = holdStatusVal.col;
    const value = holdStatusVal.val;
    updatestatus(docobj, col, value);
    if (comments != "") {
      update_doc_status_record(docobj, "comment", comments);
    }
    setIsStatusChange(false);
    setComments("");
  };
  const handleCommentsChange = (event) => {
    setComments(event.target.value);
  };
  const handleAddAdharDesign = ()=>{
    setAdharextraDesing(0);
    const updatedAdhar = [...documentsData.adhar];
    updatedAdhar[1]['status'] = "1";
    setDocumentsData((prevState) => ({
      ...prevState,
      adhar: updatedAdhar,
    }));

  }
  const handledocStatusChange = (docobj, col, value) => {
    const docType = docobj.type;
    const key = docobj.key;
    setHoldStatusVal((pre) => ({
      ...pre,
      type: docobj,
      col: col,
      val: value,
    }));

    // Call update_doc_data with correct parameters
    setStatusObj((prevState) => ({
      ...prevState,
      type: docType.charAt(0).toUpperCase() + docType.slice(1),
      clickType: value,
    }));

    if (value == "4") {
      axios({
        method: "post",
        url: `${constant.base_url}/student/student_doc_billing.php?fun=update_doc_status_record_check`,
        headers: { "Auth-Id": user.auth_id },
        data: { type: docobj, col: col, value: value },
      })
        .then(function (response) {
          checkUserLogin(response);
          if (response.data.data.status === "0") {
            setIsStatusChange(true);
          } else {
            //toast.warn(response.data.data.msg);
          }
        })
        .catch(function (error) {
          console.error("Error during login:", error);
        });
    } else {
      setIsStatusChange(true);
    }
  };
  function updatestatus(docobj, col, value) {
    // Use docobj.type to get the key
    const docType = docobj.type;
    const key = docobj.key;

    // Ensure `documentsData` is a valid object and `docType` exists as a key
    if (!documentsData[docType]) {
      toast.error(`No data found for document type: ${docType}`);
      return;
    }

    // Make a copy of the document status array
    const updatedocstatus = [...documentsData[docType]];

    // Ensure docobj.index and field are valid
    const field = col; // Assuming 'col' is the field to update

    // Update the specific document status
    if (updatedocstatus[docobj.index] !== undefined) {
      updatedocstatus[docobj.index][key] = value;
    } else {
      console.error(`Invalid index: ${docobj.index}`);
      return;
    }

    // Update the state with the new document status
    setDocumentsData((prevState) => ({
      ...prevState,
      [docType]: updatedocstatus, // Use dynamic key correctly
    }));

    update_doc_status_record(docobj, col, value);
  }

  const update_doc_status_record = async (doc_type, col, value) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=update_doc_status_record`,
      headers: { "Auth-Id": user.auth_id },
      data: { type: doc_type, col: col, value: value },
    })
      .then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status === "1") {
          toast.success(response.data.data.msg);
        } else {
          //toast.warn(response.data.data.msg);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  };
  const update_doc_data = async (doc_type, col, value, dbid, key) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=update_doc_data`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        type: doc_type,
        col: col,
        value: value,
        objectkey: key,
        dbid: dbid,
      },
    })
      .then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status === 1) {
          getDocument();
        } else if (response.data.data.status === 2) {
          let newError = { ...errorMsg };
          newError = { ...newError, ...response.data.data.error };
          setErrorMsg(newError);
        }
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  };
  const getDocument = async () => {
    setAutoLoader(true);
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_doc_billing.php?fun=getdocumentdata`,
      headers: { "Auth-Id": user.auth_id },
      data: {},
    })
      .then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status === "1") {
          if (Object.keys(response.data.data.data).length) {
            setDocumentsData(response.data.data.data);
          }
          if (response.data.data.complsoury) {
            setComplsoury(response.data.data.complsoury);
          }
          setErrorMsg(response.data.data.error);
          if (response.data.data.address_proof_select) {
            setSelectedAddressProofs(response.data.data.address_proof_select);
          }
          if (response.data.data.admin) {
            setAdmin(response.data.data.admin);
          }
          if (response.data.data.certi_select) {
            setSelectedCertificates(response.data.data.certi_select);
          }
          if (response.data.data.licence_select) {
            setSelectedLicenseTypes(response.data.data.licence_select);
          }
          setInitialAddressProofOptions([
            ...JSON.parse(
              response.data.data.filteroption.initialAddressProofOptions
            ),
          ]);
          setCertificateOptions([
            ...JSON.parse(response.data.data.filteroption.certificateOptions),
          ]);
          setLicenseOptions([
            ...JSON.parse(response.data.data.filteroption.licenseOptions),
          ]);
          setIdProofTypeOptions([
            ...JSON.parse(response.data.data.filteroption.idProofTypeOptions),
          ]);
          setCourseListed([...response.data.data.mycourselist]);
          setDataStatus(true);
        }
        setAutoLoader(false);
        setDataStatus(true);
      })
      .catch(function (error) {
        console.error("Error during login:", error);
      });
  };

  const showIdProof = courseListed.some(id =>
    [1,2,3,21].includes(Number(id))
  );

  const showMedicalCerticate = courseListed.some(id =>
    [1,2,3,21].includes(Number(id))
  );

  const showCOCInstructorCourse = courseListed.some(id =>
    [21].includes(Number(id))
  );

  const showProofOfInstructorRating = courseListed.some(id =>
    [21].includes(Number(id))
  );

  const showLiesnce = courseListed.some(id =>
    [3,21,39,191].includes(Number(id))
  );

  const showResume = courseListed.some(id =>
    [3].includes(Number(id))
  );
  return (
    <>
      {dataStatus && (
        <div className="course-container df mr20">
          <div className="account-details df fdc flx100">
            <div className="settings-head">
              <h3 className="fc3 fw5 fs18 mt12 mb12">
                Address & ID Documents
                <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                  Upload and manage your address and ID documents here. Keep
                  your information up-to-date and easily accessible.
                </div>
              </h3>
              {complsoury.msg && (
                <p className="error-message">{complsoury.msg}</p>
              )}
              {warning && <p className="error-message">{warning}</p>}
            </div>
            <div className="document-fields mt12">
              <div className="address-proof-container">
                {documentsData.adhar.map((adhar, index) => (
                 adhar.status === "1" && ( <div
                    key={index}
                    className="form-group-settings aadhar w100 mb24"
                  >
                    <p className="fc15 fw6 fs14 ls1">
                      Aadhar Number<span className="fc5">*</span>
                    </p>
                    <input
                      type="number"
                      id="aadharId"
                      placeholder="Enter Aadhar Number"
                      autoComplete="off"
                      className={`${
                        adhar.adhardocstatus === "4" ||
                        adhar.adhardocstatus === "3" ||
                        adhar.adhardocstatus === "1"
                          ? "bg4 not-allowed"
                          : "bg1"
                      } br4 h40 mt8 fs14 w100 p16`}
                      onChange={(e) =>
                        handleChange(index, "aadharId", e.target.value)
                      }
                      onBlur={() =>
                        handleOnChangeUpdate(
                          "adhar",
                          "doc_information",
                          adhar.aadharId,
                          adhar.id,
                          `aadharId-${index}`
                        )
                      }
                      value={adhar.aadharId}
                      disabled={
                        adhar.adhardocstatus === "4" ||
                        adhar.adhardocstatus === "3" ||
                        adhar.adhardocstatus === "1"
                      }
                    />
                    {errorMsg[`aadharId-${index}`] && (
                      <p className="error-message">
                        {errorMsg[`aadharId-${index}`]}
                      </p>
                    )}

                    <div className="upload-image v-center mb16">
                      <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                        Upload Aadhar
                      </p>
                      <div className="image-upload-component flx50">
                        <ImageUpload
                          onImageUpload={(imageFile) =>
                            handleAadharImageUpload(imageFile, adhar.id)
                          }
                          imgData={adhar.image}
                          imgstatus={adhar.adhardocstatus}
                          handledocStatusChange={handledocStatusChange}
                          comment={adhar.comment}
                          admin={admin}
                          disabled={
                            adhar.adhardocstatus === "4" ||
                            adhar.adhardocstatus === "3" ||
                            adhar.adhardocstatus === "1"
                          }
                          imagedoctrel={{
                            type: "adhar",
                            doc_type: "adhar",
                            index: index,
                            dbid: adhar.id,
                            key: "adhardocstatus",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )))}
             {documentsData.adhar.length > 1 && adharextraDesing>0 &&(
              <div className="df jce mb24 mt24">
                <button
                  className="pl16 pr16 pt12 pb12 bg3 fc1 br24 ls2 cp v-center fs16"
                  onClick={handleAddAdharDesign}
                >
                  Add More
                  <AiFillPlusCircle className="ml8 fs20" />
                </button>
              </div>
            )}
              </div>
              <div className="brd-bottom-dotted pb24 "></div>
              <div className="medical pt30 pt12">
                  {documentsData.id_proof.map(
                    (id_proof, index) =>
                      id_proof.status === "1" && (
                        <div
                          key={id_proof.id}
                          className={`upload-image mt32 mb16 ${
                            getRealTimeCount("id_proof") > 1 &&
                            "brd-bottom-dotted pb24"
                          }`}
                        >
                          <div className="v-center jcsb mb24 h-input">
                          <div className="form-group-settings address-proof flx48 w100">
                            <SingleDropdown
                              label="ID Proof Type"
                              options={getAvailableIdProofOptions()}
                              selectedOption={id_proof.id_proof_type}
                              onSelect={(option) =>
                                handleDropdownChangeIdProof(option, index)
                              }
                              isReadOnly={
                                id_proof.id_proof_status === "4" ||
                                id_proof.id_proof_status === "3" ||
                                id_proof.id_proof_status === "1"
                              }
                              required
                            />
                          </div>
                          <div className="form-group-settings dob flx48 w100">
                            <label
                              htmlFor={`id_proof_number-${index}`}
                              className="df fs14 ls1 fw6"
                            >
                              ID Number<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id={`id_proof_number-${index}`}
                              placeholder="ID Number"
                              autoComplete="off"
                              className={`${
                                !id_proof.id_proof_type.value ||
                                id_proof.id_proof_status === "4" ||
                                id_proof.id_proof_status === "3" ||
                                id_proof.id_proof_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              value={id_proof.id_proof_number}
                              disabled={
                                !id_proof.id_proof_type.value ||
                                id_proof.id_proof_status === "4" ||
                                id_proof.id_proof_status === "3" ||
                                id_proof.id_proof_status === "1"
                              }
                              onChange={(e) =>
                                handleIdProofNumberChange(
                                  index,
                                  "id_proof_number",
                                  e.target.value
                                )
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  id_proof.id_proof_type.value,
                                  "doc_information",
                                  id_proof.id_proof_number,
                                  id_proof.id,
                                  `idProof-number-${index}`
                                )
                              }
                            />
                            {errorMsg[`idProof-number-${index}`] &&
                              !(
                                !id_proof.id_proof_type.value ||
                                id_proof.id_proof_status === "4" ||
                                id_proof.id_proof_status === "3" ||
                                id_proof.id_proof_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`instituteName-${index}`]}
                                </p>
                              )}
                          </div>
                        </div>
                          <div className="v-center medical-docs">
                            <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                              Upload Proof
                            </p>
                            <div className="image-upload-component flx50">
                              <ImageUpload
                                onImageUpload={(imageFile) =>
                                  handleIdProofImageUpload(
                                    id_proof.id,
                                    imageFile,
                                    id_proof.id_proof_type.value,
                                    id_proof.id
                                  )
                                }
                                imgData={id_proof.image}
                                admin={admin}
                                comment={id_proof.comment}
                                imgstatus={id_proof.id_proof_status}
                                disabled={
                                  id_proof.id_proof_status === "4" ||
                                  id_proof.id_proof_status === "3" ||
                                  id_proof.id_proof_status === "1"
                                }
                                handledocStatusChange={handledocStatusChange}
                                imagedoctrel={{
                                  type: "id_proof",
                                  doc_type: "id_proof",
                                  index: index,
                                  dbid: id_proof.id,
                                  key: "id_proof_status",
                                }}
                              />
                            </div>
                          </div>
                          {getRealTimeCount("id_proof") > 1 &&
                            id_proof.id_proof_status !== 1 &&
                            String(id_proof.id).includes("_new") && (
                              <div className="df jce mt16">
                                <button
                                  className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                                  onClick={() =>
                                    deleteIdProof(
                                      index,
                                      id_proof.id
                                    )
                                  }
                                >
                                  Delete
                                  <MdDelete className="ml8 fs20" />
                                </button>
                              </div>
                            )}
                        </div>
                      )
                  )}
                </div>
              
              <div className="brd-bottom-dotted pb24 "></div>
              <div className="address-proof-container">
                {documentsData.addressProofs.map(
                  (addressProof, index) =>
                    addressProof.status === "1" && (
                      <div
                        className={`certificate-container  mt24 ${
                          getRealTimeCount("addressproof") > 1 &&
                          "brd-bottom-dotted pb24 "
                        }`}
                      >
                        <div
                          key={index}
                          className="v-center jcsb mb24 h-input pt32 mt24  "
                        >
                          <div className="form-group-settings address-proof flx48 w100">
                            <SingleDropdown
                              label="Address Proof"
                              options={getAvailableAddressProofOptions()}
                              selectedOption={addressProof.addProofType}
                              onSelect={(option) =>
                                handleDropdownChangeAddress(option, index)
                              }
                              isReadOnly={
                                addressProof.addressproof_status === "4" ||
                                addressProof.addressproof_status === "3" ||
                                addressProof.addressproof_status === "1"
                              }
                              required
                            />
                          </div>
                          <div className="form-group-settings dob flx48 w100">
                            <label
                              htmlFor="addProofId"
                              className="df fs14 ls1 fw6"
                            >
                              Address Proof ID<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id="addProofId"
                              placeholder={
                                addressProof.addProofType?.label
                                  ? `Enter ${addressProof.addProofType.label} ID`
                                  : "Enter ID"
                              }
                              autoComplete="off"
                              className={`${
                                !addressProof.addProofType.value ||
                                addressProof.addressproof_status === "4" ||
                                addressProof.addressproof_status === "3" ||
                                addressProof.addressproof_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) => {
                                const updatedProofs = [
                                  ...documentsData.addressProofs,
                                ];
                                updatedProofs[index].addProofId =
                                  e.target.value;
                                setDocumentsData((prevState) => ({
                                  ...prevState,
                                  addressProofs: updatedProofs,
                                }));
                              }}
                              value={addressProof.addProofId}
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  addressProof.addProofType?.value,
                                  "doc_information",
                                  addressProof.addProofId,
                                  addressProof.id
                                )
                              }
                              disabled={
                                !addressProof.addProofType.value ||
                                addressProof.addressproof_status === "4" ||
                                addressProof.addressproof_status === "3" ||
                                addressProof.addressproof_status === "1"
                              }
                            />
                            {getErrorMessage(
                              addressProof.addProofType.value,
                              errorMsg
                            ) &&
                              !(
                                !addressProof.addProofType.value ||
                                addressProof.addressproof_status === "4" ||
                                addressProof.addressproof_status === "3" ||
                                addressProof.addressproof_status === "1"
                              ) && (
                                <p className="error-message">
                                  {getErrorMessage(
                                    addressProof.addProofType.value,
                                    errorMsg
                                  )}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="upload-image v-center mb16">
                          <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                            Upload {addressProof.addProofType.label} Proof
                          </p>
                          <div className="image-upload-component flx50">
                            <ImageUpload
                              onImageUpload={(imageFile) =>
                                handleAddressProofImageUpload(
                                  index,
                                  imageFile,
                                  addressProof.addProofType.value,
                                  addressProof.id
                                )
                              }
                              imgData={addressProof.image}
                              imgstatus={addressProof.addressproof_status}
                              admin={admin}
                              comment={addressProof.comment}
                              handledocStatusChange={handledocStatusChange}
                              disabled={
                                !addressProof.addProofType.value ||
                                addressProof.addressproof_status === "4" ||
                                addressProof.addressproof_status === "3" ||
                                addressProof.addressproof_status === "1"
                              }
                              imagedoctrel={{
                                type: "addressProofs",
                                doc_type: addressProof.addProofType.value,
                                index: index,
                                dbid: addressProof.id,
                                key: "addressproof_status",
                              }}
                            />
                          </div>
                        </div>

                        {getRealTimeCount("addressproof") > 1 &&
                          addressProof.addressproof_status !== 4 &&
                          String(addressProof.id).includes("_new") &&
                          !admin && (
                            <div className="df jce mt16">
                              <button
                                className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                                onClick={() =>
                                  handleDeleteAddressProof(
                                    index,
                                    addressProof.id
                                  )
                                }
                              >
                                Delete
                                <MdDelete className="ml8 fs20" />
                              </button>
                            </div>
                          )}
                      </div>
                    )
                )}
                {selectedAddressProofs.length <
                  initialAddressProofOptions.length && (
                  <div className="df jce mb24 mt24">
                    <button
                      className="pl16 pr16 pt12 pb12 bg3 fc1 br24 ls2 cp v-center fs16"
                      onClick={() => handleAddAddressProof()}
                    >
                      Add More
                      <AiFillPlusCircle className="ml8 fs20" />
                    </button>
                  </div>
                )}
              </div>

              <div className="certificates brd-t2 pt12">
                <div className="certificates-head">
                  <h3 className="fc3 fw5 fs20 mt12 mb24">
                    Certificates
                    <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                      Upload your educational degrees and certificates to
                      maintain a comprehensive record of your qualifications.
                      {[10, 12, "ug", "pg"].includes(complsoury.compulsory) && (
                        <p className="error-message">{complsoury.msg}</p>
                      )}
                      {complsoury.msg && (
                        <p className="error-message">{complsoury.msg}</p>
                      )}
                    </div>
                  </h3>
                </div>

                {documentsData.certificates.map(
                  (certificate, index) =>
                    certificate.status === "1" && (
                      <div
                        key={index}
                        className={`certificate-container  mt24 df fww jcsb ${
                          getRealTimeCount("certificate") > 1 &&
                          "brd-bottom-dotted pb24"
                        }`}
                      >
                          <div className="form-group-settings address-proof flx48 w100 mb24">
                            <SingleDropdown
                              label="Education"
                              options={getAvailableCertificateOptions()}
                              selectedOption={certificate.certificateType}
                              onSelect={(option) =>
                                handleCertificateChange(index, {
                                  target: {
                                    id: "certificateType",
                                    value: option,
                                  },
                                })
                              }
                              isReadOnly={
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              }
                              required
                            />
                          </div>
                          <div className="form-group-settings dob flx48 w100 mb24">
                            <label
                              htmlFor="schoolName"
                              className="df fs14 ls1 fw6"
                            >
                              {certificate.certificateType.value === "10th" ||
                              certificate.certificateType.value === "12th"
                                ? "School Name"
                                : certificate.certificateType.value === "degree"
                                ? "College / University Name"
                                : "Institute Name"}
                              <span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id="schoolName"
                              placeholder={`Enter ${
                                certificate.certificateType.value === "10th" ||
                                certificate.certificateType.value === "12th"
                                  ? "School Name"
                                  : certificate.certificateType.value ===
                                    "degree"
                                  ? "College / University Name"
                                  : "Institute Name"
                              }`}
                              autoComplete="off"
                              className={`${
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                              value={certificate.schoolName}
                              disabled={
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  certificate.certificateType.value,
                                  "other_json_data",
                                  certificate.schoolName,
                                  certificate.id,
                                  `schoolName-${index}`
                                )
                              }
                            />
                            {errorMsg[`schoolName-${index}`] &&
                              !(
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`schoolName-${index}`]}
                                </p>
                              )}
                          </div>
                          {(certificate.certificateType.label === "Diploma" ||
                            certificate.certificateType.label === "Degree") && (
                            <div className="form-group-settings address-proof flx48 w100 mb24">
                              <label
                                htmlFor="courseName"
                                className="df fs14 ls1 fw6"
                              >
                                Course Name
                                <span className="fc5">*</span>
                              </label>
                              <input
                                type="text"
                                id="courseName"
                                placeholder={`Enter Course Name`}
                                autoComplete="off"
                                className={`${
                                  !certificate.certificateType.value ||
                                  certificate.certificate_status === "4" ||
                                  certificate.certificate_status === "3" ||
                                  certificate.certificate_status === "1"
                                    ? "bg4 not-allowed"
                                    : "bg1"
                                } br4 h40 mt8 fs14 w100 p16`}
                                onChange={(e) =>
                                  handleCertificateChange(index, e)
                                }
                                value={certificate.courseName}
                                disabled={
                                  !certificate.certificateType.value ||
                                  certificate.certificate_status === "4" ||
                                  certificate.certificate_status === "3" ||
                                  certificate.certificate_status === "1"
                                }
                                onBlur={() =>
                                  handleOnChangeUpdate(
                                    certificate.certificateType.value,
                                    "other_json_data",
                                    certificate.courseName,
                                    certificate.id,
                                    `courseName-${index}`
                                  )
                                }
                              />
                              {errorMsg[`courseName-${index}`] &&
                                !(
                                  !certificate.certificateType.value ||
                                  certificate.certificate_status === "4" ||
                                  certificate.certificate_status === "3" ||
                                  certificate.certificate_status === "1"
                                ) && (
                                  <p className="error-message">
                                    {errorMsg[`courseName-${index}`]}
                                  </p>
                                )}
                            </div>
                          )}
                          <div className="form-group-settings address-proof flx48 w100 mb24">
                            <label
                              htmlFor="certificateNumber"
                              className="df fs14 ls1 fw6"
                            >
                              {certificate.certificateType.value === "10th" ||
                              certificate.certificateType.value === "12th"
                                ? "Roll Number"
                                : "Certificate Number"}
                              <span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id="certificateNumber"
                              placeholder={`Enter ${
                                certificate.certificateType.value === "10th" ||
                                certificate.certificateType.value === "12th"
                                  ? "Roll Number"
                                  : "Certificate Number"
                              }`}
                              autoComplete="off"
                              className={`${
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                              value={certificate.certificateNumber}
                              disabled={
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  certificate.certificateType.value,
                                  "other_json_data",
                                  certificate.certificateNumber,
                                  certificate.id,
                                  `certificateNumber-${index}`
                                )
                              }
                            />
                            {errorMsg[`certificateNumber-${index}`] &&
                              !(
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`certificateNumber-${index}`]}
                                </p>
                              )}
                          </div>
                          <div className="form-group-settings dob flx48 w100 mb24">
                            <label
                              htmlFor="c_passingYear"
                              className="df fs14 ls1 fw6"
                            >
                              Passing Year<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id="c_passingYear"
                              placeholder="Enter Passing Year"
                              autoComplete="off"
                              className={`${
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                              value={certificate.c_passingYear}
                              disabled={
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  certificate.certificateType.value,
                                  "other_json_data",
                                  certificate.c_passingYear,
                                  certificate.id,
                                  `c_passingYear-${index}`
                                )
                              }
                            />
                            {errorMsg[`c_passingYear-${index}`] &&
                              !(
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`c_passingYear-${index}`]}
                                </p>
                              )}
                          </div>
                          <div className="form-group-settings dob flx48 w100 mb24">
                            <label
                              htmlFor="percentage"
                              className="df fs14 ls1 fw6"
                            >
                              Percentage
                            </label>
                            <input
                              type="text"
                              id="percentage"
                              placeholder="Enter Percentage"
                              autoComplete="off"
                              className={`${
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                              value={certificate.percentage}
                              disabled={
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3"
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  certificate.certificateType.value,
                                  "other_json_data",
                                  certificate.percentage,
                                  certificate.id,
                                  `percentage-${index}`
                                )
                              }
                            />
                            {errorMsg[`percentage-${index}`] &&
                              !(
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`percentage-${index}`]}
                                </p>
                              )}
                          </div>
                          <div className="form-group-settings address-proof flx48 w100 mb24">
                            <label
                              htmlFor="marksObtained"
                              className="df fs14 ls1 fw6"
                            >
                              Marks Obtained
                            </label>
                            <input
                              type="text"
                              id="marksObtained"
                              placeholder="Enter Marks Obtained"
                              autoComplete="off"
                              className={`${
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                              value={certificate.marksObtained}
                              disabled={
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3"
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  certificate.certificateType.value,
                                  "other_json_data",
                                  certificate.marksObtained,
                                  certificate.id,
                                  `marksObtained-${index}`
                                )
                              }
                            />
                            {errorMsg[`marksObtained-${index}`] &&
                              !(
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`marksObtained-${index}`]}
                                </p>
                              )}
                          </div>
                          <div className="form-group-settings address-proof flx48 w100 mb24">
                            <label
                              htmlFor="c_place"
                              className="df fs14 ls1 fw6"
                            >
                              Place
                            </label>
                            <input
                              type="text"
                              id="c_place"
                              placeholder="Enter Place"
                              autoComplete="off"
                              className={`${
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              onChange={(e) =>
                                handleCertificateChange(index, e)
                              }
                              value={certificate.c_place}
                              disabled={
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  certificate.certificateType.value,
                                  "other_json_data",
                                  certificate.c_place,
                                  certificate.id,
                                  `c_place-${index}`
                                )
                              }
                            />
                            {errorMsg[`c_place-${index}`] &&
                              !(
                                !certificate.certificateType.value ||
                                certificate.certificate_status === "4" ||
                                certificate.certificate_status === "3" ||
                                certificate.certificate_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`c_place-${index}`]}
                                </p>
                              )}
                          </div>
                        {certificate.certificateType.value && (
                          <div className="upload-image v-center mb16 w100">
                            <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                              Upload {certificate.certificateType.label}{" "}
                              Certificate
                            </p>
                            <div className="image-upload-component flx50">
                              <ImageUpload
                                onImageUpload={(imageFile) =>
                                  handleCertificateImageUpload(
                                    index,
                                    imageFile,
                                    certificate.certificateType.value,
                                    certificate.id
                                  )
                                }
                                imgData={certificate.image}
                                admin={admin}
                                comment={certificate.comment}
                                imgstatus={certificate.certificate_status}
                                handledocStatusChange={handledocStatusChange}
                                disabled={
                                  !certificate.certificateType.value ||
                                  certificate.certificate_status === "4" ||
                                  certificate.certificate_status === "3" ||
                                  certificate.certificate_status === "1"
                                }
                                imagedoctrel={{
                                  type: "certificates",
                                  doc_type: certificate.certificateType.value,
                                  index: index,
                                  dbid: certificate.id,
                                  key: "certificate_status",
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {getRealTimeCount("certificate") > 1 &&
                          certificate.certificate_status !== 1 &&
                          String(certificate.id).includes("_new") && (
                            <div className="df jce mt16">
                              <button
                                className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 v-center"
                                onClick={() =>
                                  handleDeleteCertificate(index, certificate.id)
                                }
                              >
                                Delete
                                <MdDelete className="ml8 fs20" />
                              </button>
                            </div>
                          )}
                      </div>
                    )
                )}
                {selectedCertificates.length < certificateOptions.length && (
                  <div className="df jce mb24 mt24">
                    <button
                      className="pl16 pr16 pt12 pb12 bg3 fc1 br24 ls2 cp v-center fs16"
                      onClick={handleAddCertificate}
                    >
                      Add More
                      <AiFillPlusCircle className="ml8 fs20" />
                    </button>
                  </div>
                )}
              </div>
              {showLiesnce && (
              <div className="license-rpc brd-t2 pt12">
                <div className="certificates-head">
                  <h3 className="fc3 fw5 fs20 mt12 mb24">
                    RPC Licence
                    <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                      Please upload clear and legible copies of your RPC Licence.
                      This document is essential for verifying your
                      eligibility and credential.
                    </div>
                  </h3>
                </div>

                {documentsData.license.map(
                  (license, index) =>
                    license.status === "1" && (
                      <div
                        key={index}
                        className={`license-container mt24 ${
                          getRealTimeCount("license") > 1 &&
                          "brd-bottom-dotted pb24"
                        }`}
                      >
                        <div className="v-center jcsb mb24 h-input">
                          {/*<div className="form-group-settings address-proof flx48 w100">
                            <SingleDropdown
                              label="Licences Type"
                              options={getAvailableLicenseOptions()}
                              selectedOption={license.licenseType}
                              onSelect={(option) =>
                                handleDropdownChangeLicense(option, index)
                              }
                              isReadOnly={
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              }
                              required
                            />
                          </div>*/}
                          <div className="form-group-settings dob flx48 w100">
                            <label
                              htmlFor={`instituteName-${index}`}
                              className="df fs14 ls1 fw6"
                            >
                              Institute Name<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id={`instituteName-${index}`}
                              placeholder="Institute Name"
                              autoComplete="off"
                              className={`${
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              value={license.instituteName}
                              disabled={
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              }
                              onChange={(e) =>
                                handleLicenseChange(
                                  index,
                                  "instituteName",
                                  e.target.value
                                )
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  license.licenseType.value,
                                  "other_json_data",
                                  license.instituteName,
                                  license.id,
                                  `instituteName-${index}`
                                )
                              }
                            />
                            {errorMsg[`instituteName-${index}`] &&
                              !(
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`instituteName-${index}`]}
                                </p>
                              )}
                          </div>
                          <div className="form-group-settings dob flx48 w100">
                            <label
                              htmlFor={`l_place-${index}`}
                              className="df fs14 ls1 fw6"
                            >
                              Place<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id={`l_place-${index}`}
                              placeholder="Place"
                              autoComplete="off"
                              className={`${
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              value={license.l_place}
                              disabled={
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              }
                              onChange={(e) =>
                                handleLicenseChange(
                                  index,
                                  "l_place",
                                  e.target.value
                                )
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  license.licenseType.value,
                                  "other_json_data",
                                  license.l_place,
                                  license.id,
                                  `l_place-${index}`
                                )
                              }
                            />
                            {errorMsg[`l_place-${index}`] &&
                              !(
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`l_place-${index}`]}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="v-center jcsb mb24 h-input">
                          <div className="form-group-settings address-proof flx48 w100">
                            <label
                              htmlFor={`l_passingYear-${index}`}
                              className="df fs14 ls1 fw6"
                            >
                              Passing Year<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id={`l_passingYear-${index}`}
                              placeholder="Passing Year"
                              autoComplete="off"
                              className={`${
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              value={license.l_passingYear}
                              disabled={
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              }
                              onChange={(e) =>
                                handleLicenseChange(
                                  index,
                                  "l_passingYear",
                                  e.target.value
                                )
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  license.licenseType.value,
                                  "other_json_data",
                                  license.l_passingYear,
                                  license.id,
                                  `l_passingYear-${index}`
                                )
                              }
                            />
                            {errorMsg[`l_passingYear-${index}`] &&
                              !(
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`l_passingYear-${index}`]}
                                </p>
                              )}
                          </div>
                          <div className="form-group-settings dob flx48 w100">
                            <label
                              htmlFor={`licenseNumber-${index}`}
                              className="df fs14 ls1 fw6"
                            >
                              Licences Number<span className="fc5">*</span>
                            </label>
                            <input
                              type="text"
                              id={`licenseNumber-${index}`}
                              placeholder="Licences Number"
                              autoComplete="off"
                              className={`${
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                                  ? "bg4 not-allowed"
                                  : "bg1"
                              } br4 h40 mt8 fs14 w100 p16`}
                              value={license.licenseNumber}
                              disabled={
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              }
                              onChange={(e) =>
                                handleLicenseChange(
                                  index,
                                  "licenseNumber",
                                  e.target.value
                                )
                              }
                              onBlur={() =>
                                handleOnChangeUpdate(
                                  license.licenseType.value,
                                  "other_json_data",
                                  license.licenseNumber,
                                  license.id,
                                  `licenseNumber-${index}`
                                )
                              }
                            />
                            {errorMsg[`licenseNumber-${index}`] &&
                              !(
                                !license.licenseType.value ||
                                license.license_status === "4" ||
                                license.license_status === "3" ||
                                license.license_status === "1"
                              ) && (
                                <p className="error-message">
                                  {errorMsg[`licenseNumber-${index}`]}
                                </p>
                              )}
                          </div>
                        </div>
                        {license.licenseType.value && (
                          <div className="upload-image v-center mb16">
                            <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                              Upload License Image
                            </p>
                            <div className="image-upload-component flx50">
                              <ImageUpload
                                onImageUpload={(imageFile) =>
                                  handleCertificateImageUpload(
                                    index,
                                    imageFile,
                                    license.licenseType.value,
                                    license.id
                                  )
                                }
                                imgData={license.image}
                                admin={admin}
                                comment={license.comment}
                                imgstatus={license.license_status}
                                acceptedFormats="image/*,application/pdf"
                                handledocStatusChange={handledocStatusChange}
                                disabled={
                                  !license.licenseType.value ||
                                  license.license_status === "4" ||
                                  license.license_status === "3" ||
                                  license.license_status === "1"
                                }
                                imagedoctrel={{
                                  type: "license",
                                  doc_type: license.licenseType.value,
                                  index: index,
                                  dbid: license.id,
                                  key: "license_status",
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {getRealTimeCount("license") > 1 &&
                          license.license_status !== 1 &&
                          String(license.id).includes("_new") && (
                            <div className="df jce mt16">
                              <button
                                onClick={() => removeLicense(index, license.id)}
                                className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                              >
                                Delete
                                <MdDelete className="ml8 fs20" />
                              </button>
                            </div>
                          )}
                      </div>
                    )
                )}
                {selectedLicenseTypes.length < licenseOptions.length && (
                  <div className="df jce mb24 mt24">
                    <button
                      className="pl16 pr16 pt12 pb12 bg3 fc1 br24 ls2 cp v-center fs16"
                      onClick={addLicense}
                    >
                      Add More
                      <AiFillPlusCircle className="ml8 fs20" />
                    </button>
                  </div>
                )}
              </div>
              )}
              {showMedicalCerticate && (
              <div className="medical brd-t2 pt12">
                <div className="medical-head">
                  <h3 className="fc3 fw5 fs20 mt12 mb12">
                    Medical Certificate
                    <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                      Upload your medical certificate to make sure you comply
                      with drone regulations and maintain up-to-date records.
                    </div>
                  </h3>
                </div>
                {documentsData.medicalCertificates.map(
                  (certificate, index) =>
                    certificate.status === "1" && (
                      <div
                        key={certificate.id}
                        className={`upload-image  mb16 ${
                          getRealTimeCount("medical") > 1 &&
                          "brd-bottom-dotted pb24"
                        }`}
                      >
                        <div className="v-center medical-docs">
                          <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                            Upload Medical Certificate
                          </p>
                          <div className="image-upload-component flx50">
                            <ImageUpload
                              onImageUpload={(imageFile) =>
                                handleMedicalCertificateImageUpload(
                                  certificate.id,
                                  imageFile,
                                  index,
                                  certificate.id
                                )
                              }
                              imgData={certificate.image}
                              admin={admin}
                              comment={certificate.comment}
                              imgstatus={certificate.medical_cert_status}
                              disabled={
                                certificate.medical_cert_status === "4" ||
                                certificate.medical_cert_status === "3" ||
                                certificate.medical_cert_status === "1"
                              }
                              handledocStatusChange={handledocStatusChange}
                              imagedoctrel={{
                                type: "medicalCertificates",
                                doc_type: "medical",
                                index: index,
                                dbid: certificate.id,
                                key: "medical_cert_status",
                              }}
                            />
                          </div>
                        </div>
                        {getRealTimeCount("medical") > 1 &&
                          certificate.medical_cert_status !== 1 &&
                          String(certificate.id).includes("_new") && (
                            <div className="df jce mt16">
                              <button
                                className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                                onClick={() =>
                                  deleteMedicalCertificate(
                                    index,
                                    certificate.id
                                  )
                                }
                              >
                                Delete
                                <MdDelete className="ml8 fs20" />
                              </button>
                            </div>
                          )}
                      </div>
                    )
                )}

                {getRealTimeCount("medical") <= maxmedicalcertificate && (
                  <div className="df jce mb24 mt24">
                    <button
                      className="pl16 pr16 pt12 pb12 bg3 fc1 br24 ls2 cp v-center fs16"
                      onClick={addNewMedicalCertificate}
                    >
                      Add More
                      <AiFillPlusCircle className="ml8 fs20" />
                    </button>
                  </div>
                )}
              </div>
              )}
              {showResume && (
              <div className="medical brd-t2 pt12">
                <div className="medical-head">
                  <h3 className="fc3 fw5 fs20 mt12 mb12">
                    Resume
                    <div className="fs14 fc16 mt8 fw4 fc6 lh18">Please upload your updated resume in PDF format only.</div>
                  </h3>
                </div>
                {documentsData.resume.map((certificate, index) =>
                  certificate.status === "1" && (
                    <div
                      key={certificate.id}
                      className={`upload-image  mb16 ${
                        getRealTimeCount("resume") > 1 &&
                        "brd-bottom-dotted pb24"
                      }`}
                    >
                      <div className="v-center medical-docs">
                        <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                          Upload Resume
                        </p>
                        <div className="image-upload-component flx50">
                          <ImageUpload
                            onImageUpload={(imageFile) =>
                              handleResumeImageUpload(
                                certificate.id,
                                imageFile,
                                index,
                                certificate.id
                              )
                            }
                            imgData={certificate.image}
                            admin={admin}
                            comment={certificate.comment}
                            imgstatus={certificate.resume_status}
                            disabled={
                              certificate.resume_status === "4" ||
                              certificate.resume_status === "3" ||
                              certificate.resume_status === "1"
                            }
                            handledocStatusChange={handledocStatusChange}
                            imagedoctrel={{
                              type: "resume",
                              doc_type: "resume",
                              index: index,
                              dbid: certificate.id,
                              key: "resume_status",
                            }}
                          />
                        </div>
                      </div>
                      {getRealTimeCount("resume") > 1 &&
                        certificate.resume_status !== 1 &&
                        String(certificate.id).includes("_new") && (
                          <div className="df jce mt16">
                            <button
                              className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                              onClick={() =>
                                deleteResume(
                                  index,
                                  certificate.id
                                )
                              }
                            >
                              Delete
                              <MdDelete className="ml8 fs20" />
                            </button>
                          </div>
                        )}
                    </div>
                  )
                )}
              </div>
              )}
              {showCOCInstructorCourse && (
              <div className="medical brd-t2 pt12">
                <div className="medical-head">
                  <h3 className="fc3 fw5 fs20 mt12 mb12">
                    COC Instructor Course
                    <div className="fs14 fc16 mt8 fw4 fc6 lh18">Please upload your Certificate of Completion (COC) in PDF or image format.</div>
                  </h3>
                </div>
                {documentsData.cocInstructorCourse.map((certificate, index) =>
                  certificate.status === "1" && (
                    <div
                      key={certificate.id}
                      className={`upload-image  mb16 ${
                        getRealTimeCount("cocInstructorCourse") > 1 &&
                        "brd-bottom-dotted pb24"
                      }`}
                    >
                      <div className="v-center medical-docs">
                        <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                          Upload COC Instructor Course
                        </p>
                        <div className="image-upload-component flx50">
                          <ImageUpload
                            onImageUpload={(imageFile) =>
                              handleCocInstructorCourseImageUpload(
                                certificate.id,
                                imageFile,
                                index,
                                certificate.id
                              )
                            }
                            imgData={certificate.image}
                            admin={admin}
                            comment={certificate.comment}
                            imgstatus={certificate.coc_instructor_course_status}
                            disabled={
                              certificate.coc_instructor_course_status === "4" ||
                              certificate.coc_instructor_course_status === "3" ||
                              certificate.coc_instructor_course_status === "1"
                            }
                            handledocStatusChange={handledocStatusChange}
                            imagedoctrel={{
                              type: "coc_instructor_course",
                              doc_type: "cocInstructorCourse",
                              index: index,
                              dbid: certificate.id,
                              key: "coc_instructor_course_status",
                            }}
                          />
                        </div>
                      </div>
                      {getRealTimeCount("cocInstructorCourse") > 1 &&
                        certificate.coc_instructor_course_status !== 1 &&
                        String(certificate.id).includes("_new") && (
                          <div className="df jce mt16">
                            <button
                              className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                              onClick={() =>
                                deleteCOCInstructorCourse(
                                  index,
                                  certificate.id
                                )
                              }
                            >
                              Delete
                              <MdDelete className="ml8 fs20" />
                            </button>
                          </div>
                        )}
                    </div>
                  )
                )}
              </div>
              )}
              {showProofOfInstructorRating && (
              <div className="medical brd-t2 pt12">
                <div className="medical-head">
                  <h3 className="fc3 fw5 fs20 mt12 mb12">
                    Proof Of Instructor Rating
                    <div className="fs14 fc16 mt8 fw4 fc6 lh18">Please upload your instructor rating supporting document.</div>
                  </h3>
                </div>
                {documentsData.proofInstructorRating.map((certificate, index) =>
                  certificate.status === "1" && (
                    <div
                      key={certificate.id}
                      className={`upload-image  mb16 ${
                        getRealTimeCount("proofInstructorRating") > 1 &&
                        "brd-bottom-dotted pb24"
                      }`}
                    >
                      <div className="v-center medical-docs">
                        <p className="flx33 fc15 fw6 fs14 mb12 ls1">
                          Upload Proof Of Instructor Rating
                        </p>
                        <div className="image-upload-component flx50">
                          <ImageUpload
                            onImageUpload={(imageFile) =>
                              handleProofInstructorRatingImageUpload(
                                certificate.id,
                                imageFile,
                                index,
                                certificate.id
                              )
                            }
                            imgData={certificate.image}
                            admin={admin}
                            comment={certificate.comment}
                            imgstatus={certificate.proof_instructor_rating_status}
                            disabled={
                              certificate.proof_instructor_rating_status === "4" ||
                              certificate.proof_instructor_rating_status === "3" ||
                              certificate.proof_instructor_rating_status === "1"
                            }
                            handledocStatusChange={handledocStatusChange}
                            imagedoctrel={{
                              type: "proof_instructor_rating",
                              doc_type: "proofInstructorRating",
                              index: index,
                              dbid: certificate.id,
                              key: "proof_instructor_rating_status",
                            }}
                          />
                        </div>
                      </div>
                      {getRealTimeCount("proofInstructorRating") > 1 &&
                        certificate.proof_instructor_rating_status !== 1 &&
                        String(certificate.id).includes("_new") && (
                          <div className="df jce mt16">
                            <button
                              className="pl16 pr16 pt8 pb8 bg5 fc1 br24 ls1 cp fs14 jce v-center"
                              onClick={() =>
                                deleteProofInstructorRating(
                                  index,
                                  certificate.id
                                )
                              }
                            >
                              Delete
                              <MdDelete className="ml8 fs20" />
                            </button>
                          </div>
                        )}
                    </div>
                  )
                )}
              </div>
              )}
            </div>
          </div>
          {isStatusChage && (
            <Popup
              onClose={closePopup}
              title={"Enter Reason - " + (statusObj.type === "Adhar" ? "Aadhar" : 
                statusObj.type === "MedicalCertificates" ? "Medical Certificate" : 
                statusObj.type === "AddressProofs" ? "Address Proof" : statusObj.type)}
       
            >
              <div className="comments-input mt24">
                <label className="fc15 fw6 fs14 mb12 ls1">Comment</label>
                <textarea
                  className="comments p12 br4"
                  placeholder="Any Comment..."
                  value={comments}
                  onChange={handleCommentsChange}
                  rows="4"
                />
              </div>
              <div className="button-container mt32 myteam-filters">
                <button
                  className="cp br24 fc1 bg3 pb10 pl20 pr20 pt10"
                  onClick={onSubmitPop}
                >
                  Submit
                </button>
                <button className="btn-cancel clear" onClick={closePopup}>
                  Cancel
                </button>
              </div>
            </Popup>
          )}
          <ToastContainer position="bottom-right" />
        </div>
      )}
    </>
  );
};

export default Document;
